import consultaengIcon from '@/assets/apps/consultaeng.png'
import eletricRIcon from '@/assets/apps/eletric-r.svg'
import universidadeIcon from '@/assets/apps/universidadev2.png'
import { VIEW_PATHS, type AppView } from './navigation'

export type AppSegmentKey = 'featured' | 'training' | 'engineering' | 'sales'

export interface MenuApp {
  key: string
  href: string
  monogram: string
  imageSrc?: string
  imageClassName?: string
  segmentKeys: readonly AppSegmentKey[]
  tileClassName: string
  cardClassName: string
  internalView?: AppView
  openInNewTab?: boolean
  requiresElectricStudio?: boolean
}

export const MENU_APPS: MenuApp[] = [
  {
    key: 'university', href: 'https://universidade.brasiltec.ind.br', monogram: 'U',
    imageSrc: universidadeIcon, imageClassName: 'h-11 w-11 object-contain',
    segmentKeys: ['featured', 'training', 'sales'],
    tileClassName: 'bg-[linear-gradient(135deg,#FFF1DE_0%,#FFD8A8_100%)] text-[#B35A00]',
    cardClassName: 'border-[#FF9B00]/20 bg-[linear-gradient(180deg,#FFF8EF_0%,#FFFFFF_100%)] hover:border-[#FF9B00]/40 hover:bg-[#FFF4E8]',
  },
  {
    key: 'consultaeng', href: 'https://consultaeng.com/', monogram: 'C',
    imageSrc: consultaengIcon, imageClassName: 'h-12 w-12 object-contain',
    segmentKeys: ['featured', 'engineering', 'sales'],
    tileClassName: 'bg-[linear-gradient(135deg,#FFF1DE_0%,#FFD8A8_100%)] text-[#B35A00]',
    cardClassName: 'border-[#FF9B00]/20 bg-[linear-gradient(180deg,#FFF8EF_0%,#FFFFFF_100%)] hover:border-[#FF9B00]/40 hover:bg-[#FFF4E8]',
  },
  {
    key: 'eletric_r', href: '/api/apps/eletric-studio/acesso', monogram: 'E',
    imageSrc: eletricRIcon, imageClassName: 'h-full w-full object-contain',
    segmentKeys: ['featured', 'engineering'], requiresElectricStudio: true,
    tileClassName: 'bg-[#12252e] text-[#54d1e7]',
    cardClassName: 'border-[#FF9B00]/20 bg-[linear-gradient(180deg,#FFF8EF_0%,#FFFFFF_100%)] hover:border-[#FF9B00]/40 hover:bg-[#FFF4E8]',
  },
  {
    key: 'clp_editor', href: VIEW_PATHS['clp-editor'], monogram: 'CLP',
    segmentKeys: ['featured', 'engineering'], internalView: 'clp-editor',
    tileClassName: 'bg-[#164e63] text-[#d5f3ee]',
    cardClassName: 'border-[#FF9B00]/20 bg-[linear-gradient(180deg,#FFF8EF_0%,#FFFFFF_100%)] hover:border-[#FF9B00]/40 hover:bg-[#FFF4E8]',
  },
  {
    key: 'blog', href: VIEW_PATHS.blog, monogram: 'B',
    segmentKeys: ['featured', 'training', 'sales'], internalView: 'blog', openInNewTab: true,
    tileClassName: 'bg-[linear-gradient(135deg,#FFF1DE_0%,#FFD8A8_100%)] text-[#B35A00]',
    cardClassName: 'border-[#FF9B00]/20 bg-[linear-gradient(180deg,#FFF8EF_0%,#FFFFFF_100%)] hover:border-[#FF9B00]/40 hover:bg-[#FFF4E8]',
  },
]

export const menuAppsForVisitor = (electricStudioEnabled: boolean) =>
  MENU_APPS.filter((item) => !item.requiresElectricStudio || electricStudioEnabled)
